var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.97812C2 8.6624 2 8.00452 2.28307 7.43839C2.56614 6.87225 3.09243 6.47753 4.14501 5.6881L7.36253 3.27496C8.30049 2.57149 8.76947 2.21975 9.27993 2.08669C9.76851 1.95935 10.2831 1.97252 10.7645 2.12474C11.2675 2.28376 11.7178 2.65906 12.6186 3.40964L14.8297 5.25227C16.393 6.55504 17.1747 7.20643 18.1065 7.23031C19.0382 7.25418 19.8523 6.64369 21.4802 5.42269L22.1095 4.95075C23.7666 3.70792 26.1314 4.89032 26.1314 6.9617V16.6813V18.0219C26.1314 19.3376 26.1314 19.9955 25.8484 20.5616C25.5652 21.1278 25.0389 21.5224 23.9864 22.3119L20.7688 24.7251C19.8309 25.4285 19.3619 25.7803 18.8515 25.9133C18.3628 26.0406 17.8483 26.0275 17.3669 25.8753C16.8639 25.7163 16.4135 25.341 15.5128 24.5903L12.6186 22.1785C11.7178 21.4279 11.2675 21.0525 10.7645 20.8935C10.2831 20.7414 9.76851 20.7282 9.27993 20.8556C8.76947 20.9886 8.30049 21.3404 7.36253 22.0438C6.44835 22.7294 5.99126 23.0722 5.64263 23.2061C4.17153 23.7712 2.53269 22.9518 2.10205 21.4358C2 21.0767 2 20.5053 2 19.3625V11.3188V9.97812Z",
    stroke: "#476A89",
    strokeWidth: 2.81533,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0876 7.60425V25.3955",
    stroke: "#476A89",
    strokeWidth: 2.81533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0438 2.60474V20.3122",
    stroke: "#476A89",
    strokeWidth: 2.81533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMapIcon);
export default __webpack_public_path__ + "static/media/menu-map-icon.56cc2975ac6066d3d1540121bffc8af9.svg";
export { ForwardRef as ReactComponent };